import BadgeId from "../../../components/common/BadgeId";
import useCerokmSourceData from "../../../components/common/react-hooks/useGetCachedDocIdBatched";
import LegoContextSummary from "../../../components/lego/LegoContextSummary";
import { stringToColor } from '../../../components/common/colorUtils';

const knownDomainsIcons = {
  'www.caranddriver.com': 'https://www.caranddriver.com/_assets/design-tokens/caranddriver/static/images/favicon.02aa5c3.ico',
  'www.chevrolet.com': 'https://www.chevrolet.com/shopping/public-assets/aec-web/chevrolet/images/common/favicon.ico'
}

export function DomainIconLink({ url, children = null, size = 20, className = '' }) {
  let icon;
  try {
    const domain = new URL(url).hostname;
    const iconUrl = knownDomainsIcons[domain] || `//${domain}/favicon.ico`;
    icon = <img src={iconUrl} onError={(e) => e.target.src = '/favicon.ico'} alt={url} title={url} style={{ width: size + 'px', height: size + 'px' }} className={'rounded ' + (children ? 'mr-1' : '')} />;
  } catch (err) {
    console.log(`Failed to construct icon for url ${url}: ${err.message}`);
  }
  return <a href={url} target="_blank" className={"d-inline-flex align-items-center " + className} title={url}>
    {icon}
    {children}
  </a>
}

export default function SpecSourceBadge({ sourceId, small = false, showContext = true, className = '' }) {
  const sourceData = useCerokmSourceData('services/cerokm/source')(sourceId);

  const hashedColor = (sourceId ? stringToColor(sourceId) : '#000000') + '55';

  const size = small ? 20 : 40;

  let sourceContent = <div>??</div>;
  if (!sourceData) {
    sourceContent = <BadgeId id={sourceId} />;
  } else {
    let { sourceType, context, sourceUrl, lastVisited } = sourceData;

    if (sourceType === 'web') {
      if(sourceUrl) {
        sourceContent = <DomainIconLink url={sourceUrl} size={size}>
          <div className='inline-block ml-2'>
            {showContext && context && <LegoContextSummary context={context} inline={true} />}
            <div className='text-secondary text-wrap' style={{fontSize: '8px'}}>{sourceUrl}</div>          
          </div>
        </DomainIconLink>
      } else {
        sourceContent = <div className="mt-2 text-center">🕸{small ? '' : ' Web - no url'}</div>

      }
    } else if (sourceType === 'human') {
      sourceContent = <div className="mt-2 text-center">🖖{small ? '' : ' Human'}</div>
    } else if (sourceType === 'llm') {
      sourceContent = <div className="mt-2 text-center">🤖{small ? '' : ' LLM'}</div>
    }
  }

  return <span className={"inline-block align-middle rounded overflow-hidden border border-light " + className}
    style={{ width: showContext ? (small ? '' : '200px') : (size + 2) + 'px', height: (size + 2) + 'px', backgroundColor: hashedColor }}>
    {sourceContent}
  </span>
}
